import React, { useState } from "react";
import '@fortawesome/fontawesome-free/css/all.min.css';

// Function to get icon for each job role
const getJobIcon = (title) => {
  const titleLower = title.toLowerCase();
  if (titleLower.includes('react') || titleLower.includes('frontend')) {
    return 'fas fa-code';
  } else if (titleLower.includes('wordpress')) {
    return 'fab fa-wordpress';
  } else if (titleLower.includes('internship')) {
    return 'fas fa-user-graduate';
  } else if (titleLower.includes('full stack') || titleLower.includes('fullstack')) {
    return 'fas fa-laptop-code';
  } else if (titleLower.includes('backend')) {
    return 'fas fa-server';
  } else if (titleLower.includes('developer')) {
    return 'fas fa-code';
  }
  return 'fas fa-briefcase'; // Default icon
};

function JobList({ jobs }) {
  const [showPopup, setShowPopup] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  const openPopup = (job) => {
    setSelectedJob(job);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedJob(null);
  };

  return (
    <div className="job-listings">
      {jobs.map((job, index) => (
        <div key={index} className="job-card">
          <div className="job-card-icon">
            <i className={getJobIcon(job.title)}></i>
          </div>
          <h3>{job.title}</h3>
          <div className="job-card-info">
            <p className="job-category">
              <i className="fas fa-tag"></i> {job.category}
            </p>
            <p className="job-location">
              <i className="fas fa-map-marker-alt"></i> {job.location}
            </p>
            <p className="job-type">
              <i className="fas fa-clock"></i> {job.type}
            </p>
          </div>
          <button className="more-details-btn" onClick={() => openPopup(job)}>
            More Details <i className="fas fa-arrow-right"></i>
          </button>
        </div>
      ))}

      {showPopup && selectedJob && (
        <div className="popup-overlay">
          <div className="popup-box">
            <span className="popup-close" onClick={closePopup}>
              &times;
            </span>
            <div className="popup-body">
              <p>You can send your CV to:</p>
              <a href="mailto:humanresources@edulab.in" className="email-link">
                humanresources@edulab.in
              </a>
            </div>
          </div>
        </div>
      )}

      <style>
        {`
          /* Button Styling */
          .more-details-btn {
            color: #ffffff;
            border: 2px solid rgba(255, 255, 255, 0.5);
            background: rgba(255, 255, 255, 0.1);
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            text-decoration: none;
            transition: all 0.3s ease;
            padding: 10px 20px;
            border-radius: 25px;
            backdrop-filter: blur(10px);
            margin-top: auto;
          }

          .more-details-btn:hover {
            background: rgba(255, 255, 255, 0.2);
            border-color: rgba(255, 255, 255, 0.8);
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          }

          .more-details-btn i {
            margin-left: 5px;
            transition: transform 0.3s ease;
          }

          .more-details-btn:hover i {
            transform: translateX(3px);
          }

          /* Popup Overlay */
          .popup-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.4);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
          }

          /* Popup Box */
          .popup-box {
            background: white;
            width: 380px;
            padding: 25px;
            border-radius: 12px;
            box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
            text-align: center;
            position: relative;
            animation: fadeIn 0.3s ease-in-out;
          }

          /* Close Button */
          .popup-close {
            position: absolute;
            top: 12px;
            right: 15px;
            font-size: 22px;
            cursor: pointer;
            color: #777;
            transition: color 0.3s;
          }

          .popup-close:hover {
            color: #333;
          }

          /* Popup Body */
          .popup-body {
            font-size: 16px;
            color: #333;
            padding-top: 10px;
          }

          /* Email Link */
          .email-link {
            display: inline-block;
            margin-top: 10px;
            color: #007bff;
            font-weight: bold;
            text-decoration: none;
            font-size: 18px;
            transition: color 0.3s;
          }

          .email-link:hover {
            color: #0056b3;
            text-decoration: underline;
          }

          /* Fade-in animation */
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: scale(0.9);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }
        `}
      </style>
    </div>
  );
}

export default JobList;
